import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/global.scss'
import App from './App.vue'
import router from './router'
import { bootstrapSiteSettings, initSiteSettings } from '@/store/siteSettings'
import { initAuth, auth } from '@/store/auth'
import { historyStore } from '@/store/history'
import { loadArticles } from '@/store/articles'

Vue.use(ElementUI)

Vue.config.productionTip = false

bootstrapSiteSettings()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

initSiteSettings()
initAuth().finally(() => {
  if (auth.isLoggedIn) {
    historyStore.fetchHistory()
  }
})
loadArticles()
